import { useSearchParams } from 'react-router-dom';
import { SignupForm } from '../components/SignupForm';

export function Signup() {
  const [searchParams] = useSearchParams();
  const cancelled = searchParams.get('cancelled') === '1';

  return (
    <main className="min-h-screen text-ink flex items-center justify-center px-4 py-16" style={{ background: 'var(--color-bg)' }}>
      {/* Ambient glow — accent-soft */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 flex items-start justify-center overflow-hidden"
      >
        <div className="w-[600px] h-96 rounded-full blur-3xl -translate-y-16" style={{ background: 'var(--color-accent-soft)' }} />
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Cancelled notice */}
        {cancelled && (
          <div className="mb-6 rounded-xl border border-amber-500/30 bg-amber-500/10 px-5 py-4 text-center" role="status">
            <p className="text-sm font-medium text-amber-300">
              Payment cancelled &mdash; no charge was made.
            </p>
            <p className="mt-1 text-xs" style={{ color: 'var(--color-mute)' }}>
              Ready to try again? Fill in your details below.
            </p>
          </div>
        )}

        {/* Header */}
        <div className="mb-8 text-center">
          <p className="text-sm uppercase tracking-widest mb-3 font-medium" style={{ color: 'var(--color-accent)', fontFamily: 'var(--font-mono)' }}>
            Clarity Platform
          </p>
          <h1 className="text-3xl sm:text-4xl font-bold leading-tight tracking-tight text-ink" style={{ fontFamily: 'var(--font-display)' }}>
            Start with Pilot &mdash; $149/mo
          </h1>
          <p className="mt-3 leading-relaxed" style={{ color: 'var(--color-mute)' }}>
            Cancel any time. 30-day Hormozi gate &mdash; we&rsquo;ll refund if your wrap
            doesn&rsquo;t ship in 30 days.
          </p>
        </div>

        {/* Form card */}
        <div className="rounded-2xl p-6 sm:p-8" style={{ border: '1px solid var(--color-hairline)', background: 'var(--color-surface)' }}>
          <SignupForm />
        </div>

        {/* Trust footer */}
        <p className="mt-5 text-center text-xs" style={{ color: 'var(--color-mute)' }}>
          Payments secured by Stripe. Cancel any time from your workspace.
        </p>
      </div>
    </main>
  );
}
